import { gql } from "@apollo/client";

export const GET_VALIDAR_EQUIPO = gql`
  query GetExisteConfirmacionEquipo($idEvaluacion : Int!) {
    existeConfirmacionEquipo(idEvaluacion : $idEvaluacion) 
  }
`;